import ShadingSchemes from "../../Portal/Accessor/Shading/ShadingSchemes";
import VerticalShadingDetailV001 from "../../Portal/Accessor/Shading/V001/VerticalShadingDetail";
import HorizontalShadingDetailV001 from "../../Portal/Accessor/Shading/V001/HorizontalShadingDetail"
const AccessorShadingRouters = [
    {
        path: "ShadingAssessor/ShadingSchemes/:designVariationVersionName/:developmentId/:projectId/:designVariationId",
        exact: true,
        requireAuth: true,
        element: <ShadingSchemes/>,
        title: "Shading Schemes | AccuRate Enterprise",
    },
    {
        path: "ShadingAssessor/Detail/Vertical/:designVariationVersionName/:developmentId/:projectId/:designVariationId/:shadingId/:redirectUrlHex",
        exact: true,
        requireAuth: true,
        element: <VerticalShadingDetailV001 typeName="Vertical"/>,
        title: "Vertical Shading | AccuRate Enterprise",
    },
    {
        path: "ShadingAssessor/Detail/Horizontal/:designVariationVersionName/:developmentId/:projectId/:designVariationId/:shadingId/:redirectUrlHex",
        exact: true,
        requireAuth: true,
        element: <HorizontalShadingDetailV001 typeName="Horizontal"/>,
        title: "Horizontal Shading | AccuRate Enterprise",
    },
];
export default AccessorShadingRouters;